'use strict';

module.exports = /* @ngInject */ function() {
	return {
		restrict: 'E',
		scope: {
			userName: '=',
			showDev: '='
		},
		templateUrl: `./${BUILD_PATH}/header-user-element.directive.html`,
		controller: /* @ngInject */ function ($scope) {
			$scope.isOpen = false;
			$scope.executeWindowFn = executeWindowFn;
			$scope.openEprocContent = openEprocContent;
			$scope.openExternal = openExternal;

			function executeWindowFn(fnName){
				if(window[fnName]){
					window[fnName]();
				}
			}

			function openEprocContent(arg1, arg2, arg3) {
				if(arg1 && !arg2 && !arg3){
					window.openContent(arg1);
				} else if (arg1 && arg2 && !arg3){
					window.openContent(arg1, arg2);
				} else if(arg1 && arg2 && arg3) {
					window.openContent(arg1, arg2, arg3);
				}
			}

			function openExternal(url){
				window.open(url, '_new');
			}
		}
	};
}
